import { render, staticRenderFns } from "./yesStruct.vue?vue&type=template&id=8622f51a"
import script from "./yesStruct.vue?vue&type=script&lang=js"
export * from "./yesStruct.vue?vue&type=script&lang=js"
import style0 from "./yesStruct.vue?vue&type=style&index=0&id=8622f51a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports